import { Modal, Button } from "react-bootstrap";

const tooltipMessages = {
    1: "É um job agendado responsável por sincronizar os boletos entre o sistema e o BTG.",
    2: "É um job agendado responsável por disparar alertas para comprador sobre boletos que vão vencer em 5 dias úteis.",
    3: "É um job agendado responsável por bloquear usuários inativos após 90 dias no sistema.",
    4: "É um job agendado responsável por expirar senhas de usuários que não trocaram em um período de 1 ano.",
    5: "É um job agendado responsável por atualizar o token usado na integração com o BTG.",
    6: "É um job agendado responsável por marcar como vencidos os boletos que passaram da data.",
    7: "É um job agendado responsável por gerar os pagamentos diários do repasse e realizar as suas divisões.",
    8: "É um job agendado responsável por executa as transferências no BTG.",
    9: "É um job agendado responsável por gerar repasses financeiros para os parceiros(diferentes dos compradores comuns).",
    10: "É um job agendado responsável por enviar um alerta para os compradores caso algum de seus boletos estejam vencidos e não pagos.",
    11: "É um job agendado responsável por atualizar o status dos pedidos baseado nas parcelas.",
    12: "É um job agendado responsável por sincronizar os pagamentos entre BTG e o sistema, todos os status ficam sicronizados.",
};
const cronMessages = {
    1: "Todos os dias às 05:30 da manhã.",
    2: "Todos os dias às 09:00 da manhã.",
    3: "Todos os dias à meia-noite (00:00).",
    4: "Todos os dias à 00:05 (5 minutos após meia-noite).",
    5: "Todos os dias à 00:10.",
    6: "Todos os dias à 00:20.",
    7: "Todos os dias às 06:30 da manhã.",
    8: "Todos os dias às 07:30 da manhã.",
    9: "No dia 1 de todo mês, às 07:00 da manh.",
    10: "Todos os dias às 09:30 da manhã .",
    11: "Todos os dias à 01:00 da madrugad.",
    12: "Todos os dias às 05:30 da manhã",
};
const emergencyMessages = {
    1: "Contate um desenvolvedor.",
    2: "Contate um desenvolvedor.",
    3: "Contate um desenvolvedor.",
    4: "Contate um desenvolvedor.",
    5: "Contate um desenvolvedor.",
    6: "Contate um desenvolvedor.",
    7: "Contate um desenvolvedor.",
    8: "Contate um desenvolvedor.",
    9: "Contate um desenvolvedor.",
    10: "Contate um desenvolvedor.",
    11: "Contate um desenvolvedor.",
    12: "Contate um desenvolvedor.",
};

export default function JobInfoModal({ show, handleClose, item }) {
    return (
        <Modal show={show} onHide={handleClose}>
            <Modal.Header closeButton={false} className="d-flex justify-content-center">
                <Modal.Title>Detalhes do Job #{item.id}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p><strong>Nome:</strong> {item.nome}</p>
                <p><strong>Descrição:</strong> {tooltipMessages[item.id]}</p>
                <p><strong>Horário do Cron:</strong> {cronMessages[item.id]}</p>
                <p><strong>Caso dê erro:</strong> {emergencyMessages[item.id]}</p>

            </Modal.Body>
            <Modal.Footer className="d-flex justify-content-center">
                <Button variant="secondary" onClick={handleClose}>Fechar</Button>
            </Modal.Footer>
        </Modal>
    );
};
